
































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class MbeLegend extends Vue {
  open = false;

  toggle() {
    this.open = !this.open;
  }

  /* Close element on click outside */
  documentClick(event: any) {
    const el = this.$refs.offerLegendComponent as HTMLElement;
    if (!el.contains(event.target) && this.open) {
      this.toggle();
    }
  }
  created() {
    document.addEventListener("click", this.documentClick);
  }
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  }
}
